import { gql } from '@apollo/client';

export const GET_FINANCIAL_DATA_AVAILABILITY = gql`
  query GetFinancialDataAvailability($companyId: Int!) {
    getFinancialDataAvailability(companyId: $companyId) {
      hasPLData
      hasBalanceSheetData
      availablePeriods
      latestDataDate
    }
  }
`;

export const GET_FINANCIAL_DATA = gql`
  query GetFinancialData($companyId: Int!, $periods: [Int], $bmType: String) {
    getFinancialData(companyId: $companyId, periods: $periods, bmType: $bmType) {
      edges {
        node {
          dbId
          bmType
          category1
          category2
          category3
          value
          period
          periodType
          currency
          benchmarkControlDataId
          valuationLevel
        }
      }
    }
  }
`;

export interface FinancialDataNode {
  dbId: string;
  bmType: string;
  category1: string;
  category2?: string;
  category3?: string;
  value: number;
  period: number;
  periodType: string;
  currency: string;
  benchmarkControlDataId?: number;
  valuationLevel?: number;
}

export interface FinancialDataEdge {
  node: FinancialDataNode;
}

export interface GetFinancialDataResult {
  edges: FinancialDataEdge[];
}

export interface GetFinancialDataAvailabilityResult {
  hasPLData: boolean;
  hasBalanceSheetData: boolean;
  availablePeriods: number[];
  latestDataDate?: string;
}
